module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"home":"Hjem","listTable":"Liste","about":"Om oss"}}')
  delete Component.options._Ctor
}
